export default __webpack_public_path__ + "static/media/delivery_person.8243508b.svg";